import { Layout, Skeleton, Space } from "antd";
import React from "react";
import "./Fallbacks.css";

const { Header } = Layout;

export const TopNavFallback: React.FC = () => (
  <Header className="app-fallback-top-nav" aria-hidden>
    <Skeleton.Input active size="default" style={{ width: 120 }} />
    <Space size="middle">
      <Skeleton.Avatar active size="default" shape="circle" />
      <Skeleton.Avatar active size="default" shape="circle" />
    </Space>
  </Header>
);
